import React from 'react';
import { Helmet } from 'react-helmet-async';
import './Portofolio.css';

export default function CerebroDocumental() {
    return (
        <div className="portfolio-container">
            <Helmet>
                <title>Cerebro Documental (RAG) | Navi</title>
                <meta name="description"
                      content="Implementación de RAG para transformar PDFs y manuales estáticos en conocimiento accionable en tiempo real para el sector alimentario y administrativo."/>
            </Helmet>

            {/* --- ENCABEZADO DEL PORTFOLIO --- */}
            <header className="portfolio-header">
                <span className="portfolio-category">SECTOR: ALIMENTARIO / ADMINISTRATIVO</span>
                <h1 className="portfolio-title">Cerebro Documental (RAG)</h1>
                <h2 className="portfolio-subtitle">
                    Convierte toneladas de PDFs estáticos en conocimiento accionable. Encuentra respuestas exactas al
                    instante en tu propia base de datos no estructurada.
                </h2>
            </header>

            <div className="portfolio-hero-image">
                <img src="/imagenes_portofolio/Portofolio3_asset1.png" alt="Cerebro Documental"/>
            </div>

            {/* --- CONTENIDO --- */}
            <div className="portfolio-content">
                <p>
                    Las empresas acumulan años de manuales, especificaciones técnicas, históricos de inventario y
                    normativas. El problema es que toda esa información suele estar atrapada en documentos PDF largos y
                    difíciles de consultar, convirtiéndose en un archivo muerto.
                </p>

                <h3>El Enfoque: Búsqueda Semántica Inteligente</h3>
                <p>
                    No se trata de buscar por palabras clave exactas. Implementamos un sistema de <strong>búsqueda
                    semántica en bases de datos no estructuradas</strong>. La IA entiende el contexto de tu pregunta y
                    recupera los fragmentos de información más relevantes de entre miles de documentos.
                </p>

                <h3>La Tecnología y el Stack</h3>
                <p>
                    Utilizamos la arquitectura <strong>RAG (Recuperación Aumentada por Generación)</strong> para
                    permitirte, literalmente, "hablar" con tus manuales técnicos. Para ello, nos apoyamos en un stack
                    tecnológico robusto:
                </p>
                <ul>
                    <li><strong>Bases de Datos Vectoriales:</strong> Qdrant y ChromaDB para almacenar y recuperar la
                        "memoria semántica" de tus documentos a velocidad de milisegundos.
                    </li>
                    <li><strong>PostgreSQL:</strong> Para la gestión estructurada y segura de los metadatos de la
                        empresa.
                    </li>
                    <li><strong>Python & Playwright:</strong> Para la ingesta automatizada y procesamiento de la
                        documentación original.
                    </li>
                </ul>

                <h3>El Diferencial: Del PDF a la Acción</h3>
                <p>
                    Nuestra solución va más allá de un buscador avanzado. Se trata de desbloquear el valor oculto en tu
                    empresa.
                </p>
                <blockquote className="portfolio-quote">
                    "Transformamos PDFs y manuales estáticos en conocimiento accionable en tiempo real, accesible desde
                    cualquier dispositivo y para cualquier departamento."
                </blockquote>

                <h3>El Impacto</h3>
                <p>
                    En los sectores alimentario y administrativo, esto se traduce en una drástica <strong>reducción de
                    los tiempos de consulta técnica</strong>. Además, facilita la clasificación automatizada de
                    inventarios complejos, eliminando horas de búsqueda manual y reduciendo errores humanos.
                </p>

                {/* --- GIF DEMOSTRATIVO --- */}
                <figure className="portfolio-image-wrapper">
                    {/* Reemplaza esta ruta con la de tu GIF real */}
                    <img src="/imagenes_portofolio/Portofolio3_asset2.gif"
                         alt="Consulta semántica a manuales técnicos usando RAG"/>
                    <figcaption>Ejemplo de consulta a un manual técnico complejo y respuesta generada por IA.
                    </figcaption>
                </figure>

                {/* --- CAJA DE LLAMADA A LA ACCIÓN (CTA) --- */}
                <div className="portfolio-cta-box">
                    <h3>¿Tus empleados pierden horas buscando información?</h3>
                    <p>Descubre cómo un Cerebro Documental puede unificar todo el conocimiento de tu empresa en un solo
                        chat seguro y privado.</p>

                    <button
                        className="cta-button"
                        onClick={() => window.open(
                            'https://wa.me/34624118531?text=%C2%A1Hola!%20Me%20interesa%20conocer%20m%C3%A1s%20sobre%20el%20Cerebro%20Documental%20(RAG).',
                            '_blank'
                        )}
                    >
                        Solicitar demostración del Cerebro Documental
                    </button>
                </div>
            </div>
        </div>
    );
}